import React from 'react'
import style from "./css/Brouchure.module.css"
import Brouchure from './Brouchure'
export default function Brochures() {
  return (
    <div  className={style.brouchuresContainer}>
        <h3 className={style.heading} >Investment Brochures</h3>
         <Brouchure/>
    </div>
  )
}
